// extracted by mini-css-extract-plugin
export default {"wrap":"aF-z","subtitle":"bF-z","contentWrap":"cF-z","imgWrap":"dF-z","heading":"eF-z","copy":"fF-z"};